// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/policy/v1/policy_steps_wait.proto" (package "c1.api.policy.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { SkippedAction } from "./shared_policy_outcomes";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Duration } from "../../../../google/protobuf/duration";
/**
 * Define a Wait step for a policy to wait on a condition to be met.
 *
 * @generated from protobuf message c1.api.policy.v1.Wait
 */
export interface Wait {
    /**
     * @generated from protobuf oneof: until
     */
    until: {
        oneofKind: "condition";
        /**
         * Wait for a certain condition to be met defined by a CEL expression.
         *
         * @generated from protobuf field: c1.api.policy.v1.WaitCondition condition = 100
         */
        condition: WaitCondition;
    } | {
        oneofKind: "duration";
        /**
         * @generated from protobuf field: c1.api.policy.v1.WaitDuration duration = 101
         */
        duration: WaitDuration;
    } | {
        oneofKind: "untilTime";
        /**
         * @generated from protobuf field: c1.api.policy.v1.WaitUntilTime until_time = 102
         */
        untilTime: WaitUntilTime;
    } | {
        oneofKind: undefined;
    };
    /**
     * The name of our condition to show on the task details page
     *
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * This condition will only wait this long to continue. If not the task will close.
     *
     * @generated from protobuf field: google.protobuf.Duration timeout_duration = 2
     */
    timeoutDuration?: Duration;
    /**
     * The comment to post if we timeout.
     *
     * @generated from protobuf field: string comment_on_timeout = 3
     */
    commentOnTimeout: string;
    /**
     * The comment to post on first failed check.
     *
     * @generated from protobuf field: string comment_on_first_wait = 4
     */
    commentOnFirstWait: string;
}
/**
 * @generated from protobuf message c1.api.policy.v1.WaitCondition
 */
export interface WaitCondition {
    /**
     * The condition that has to be true for this wait condition to continue.
     *
     * @generated from protobuf field: string condition = 1
     */
    condition: string;
}
/**
 * @generated from protobuf message c1.api.policy.v1.WaitDuration
 */
export interface WaitDuration {
    /**
     * @generated from protobuf field: google.protobuf.Duration duration = 1
     */
    duration?: Duration;
}
/**
 * Waits until a specific time of the day (UTC)
 *
 * @generated from protobuf message c1.api.policy.v1.WaitUntilTime
 */
export interface WaitUntilTime {
    /**
     * @generated from protobuf field: uint32 hours = 1
     */
    hours: number;
    /**
     * @generated from protobuf field: uint32 minutes = 2
     */
    minutes: number;
    /**
     * @generated from protobuf field: string timezone = 3
     */
    timezone: string;
}
/**
 * Used by the policy engine to describe an instantiated wait step.
 *
 * @generated from protobuf message c1.api.policy.v1.WaitInstance
 */
export interface WaitInstance {
    /**
     * @generated from protobuf oneof: until
     */
    until: {
        oneofKind: "condition";
        /**
         * @generated from protobuf field: c1.api.policy.v1.WaitConditionInstance condition = 100
         */
        condition: WaitConditionInstance;
    } | {
        oneofKind: "untilTime";
        /**
         * @generated from protobuf field: c1.api.policy.v1.WaitUntilTimeInstance until_time = 104
         */
        untilTime: WaitUntilTimeInstance;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: c1.api.policy.v1.WaitInstance.WaitInstanceState state = 2
     */
    state: WaitInstance_WaitInstanceState;
    /**
     * This was when we started waiting for the condition to be met.
     *
     * @generated from protobuf field: google.protobuf.Timestamp started_waiting_at = 3
     */
    startedWaitingAt?: Timestamp;
    /**
     * This was how long the step was configured to wait for
     *
     * @generated from protobuf field: google.protobuf.Duration timeout_duration = 4
     */
    timeoutDuration?: Duration;
    /**
     * This condition will only wait until this time to continue. This value is calculated as (time_step_began + timeout).
     *
     * @generated from protobuf field: google.protobuf.Timestamp timeout = 5
     */
    timeout?: Timestamp;
    /**
     * The comment to post if we timeout.
     *
     * @generated from protobuf field: string comment_on_timeout = 6
     */
    commentOnTimeout: string;
    /**
     * The comment to post on first failed check.
     *
     * @generated from protobuf field: string comment_on_first_wait = 7
     */
    commentOnFirstWait: string;
    /**
     * @generated from protobuf oneof: outcome
     */
    outcome: {
        oneofKind: "succeeded";
        /**
         * @generated from protobuf field: c1.api.policy.v1.WaitInstance.ConditionSucceeded succeeded = 101
         */
        succeeded: WaitInstance_ConditionSucceeded;
    } | {
        oneofKind: "timedOut";
        /**
         * @generated from protobuf field: c1.api.policy.v1.WaitInstance.ConditionTimedOut timed_out = 102
         */
        timedOut: WaitInstance_ConditionTimedOut;
    } | {
        oneofKind: "skipped";
        /**
         * @generated from protobuf field: c1.api.policy.v1.SkippedAction skipped = 103
         */
        skipped: SkippedAction;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.policy.v1.WaitInstance.ConditionSucceeded
 */
export interface WaitInstance_ConditionSucceeded {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp succeeded_at = 1
     */
    succeededAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.policy.v1.WaitInstance.ConditionTimedOut
 */
export interface WaitInstance_ConditionTimedOut {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp timed_out_at = 1
     */
    timedOutAt?: Timestamp;
}
/**
 * @generated from protobuf enum c1.api.policy.v1.WaitInstance.WaitInstanceState
 */
export enum WaitInstance_WaitInstanceState {
    /**
     * @generated from protobuf enum value: WAIT_INSTANCE_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: WAIT_INSTANCE_STATE_WAITING = 1;
     */
    WAITING = 1,
    /**
     * @generated from protobuf enum value: WAIT_INSTANCE_STATE_COMPLETED = 2;
     */
    COMPLETED = 2,
    /**
     * @generated from protobuf enum value: WAIT_INSTANCE_STATE_TIMED_OUT = 3;
     */
    TIMED_OUT = 3
}
/**
 * Used by the policy engine to describe an instantiated condition to wait on.
 *
 * @generated from protobuf message c1.api.policy.v1.WaitConditionInstance
 */
export interface WaitConditionInstance {
    /**
     * The condition that has to be true for this wait condition instance to continue.
     *
     * @generated from protobuf field: string condition = 1
     */
    condition: string;
}
/**
 * @generated from protobuf message c1.api.policy.v1.WaitUntilTimeInstance
 */
export interface WaitUntilTimeInstance {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp until_time = 1
     */
    untilTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Duration duration_if_exists = 2
     */
    durationIfExists?: Duration;
}
// @generated message type with reflection information, may provide speed optimized methods
class Wait$Type extends MessageType<Wait> {
    constructor() {
        super("c1.api.policy.v1.Wait", [
            { no: 100, name: "condition", kind: "message", oneof: "until", T: () => WaitCondition },
            { no: 101, name: "duration", kind: "message", oneof: "until", T: () => WaitDuration },
            { no: 102, name: "until_time", kind: "message", oneof: "until", T: () => WaitUntilTime },
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timeout_duration", kind: "message", T: () => Duration },
            { no: 3, name: "comment_on_timeout", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "4096" } } } },
            { no: 4, name: "comment_on_first_wait", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "4096" } } } }
        ]);
    }
    create(value?: PartialMessage<Wait>): Wait {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.until = { oneofKind: undefined };
        message.name = "";
        message.commentOnTimeout = "";
        message.commentOnFirstWait = "";
        if (value !== undefined)
            reflectionMergePartial<Wait>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wait): Wait {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.policy.v1.WaitCondition condition */ 100:
                    message.until = {
                        oneofKind: "condition",
                        condition: WaitCondition.internalBinaryRead(reader, reader.uint32(), options, (message.until as any).condition)
                    };
                    break;
                case /* c1.api.policy.v1.WaitDuration duration */ 101:
                    message.until = {
                        oneofKind: "duration",
                        duration: WaitDuration.internalBinaryRead(reader, reader.uint32(), options, (message.until as any).duration)
                    };
                    break;
                case /* c1.api.policy.v1.WaitUntilTime until_time */ 102:
                    message.until = {
                        oneofKind: "untilTime",
                        untilTime: WaitUntilTime.internalBinaryRead(reader, reader.uint32(), options, (message.until as any).untilTime)
                    };
                    break;
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* google.protobuf.Duration timeout_duration */ 2:
                    message.timeoutDuration = Duration.internalBinaryRead(reader, reader.uint32(), options, message.timeoutDuration);
                    break;
                case /* string comment_on_timeout */ 3:
                    message.commentOnTimeout = reader.string();
                    break;
                case /* string comment_on_first_wait */ 4:
                    message.commentOnFirstWait = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wait, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* google.protobuf.Duration timeout_duration = 2; */
        if (message.timeoutDuration)
            Duration.internalBinaryWrite(message.timeoutDuration, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string comment_on_timeout = 3; */
        if (message.commentOnTimeout !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.commentOnTimeout);
        /* string comment_on_first_wait = 4; */
        if (message.commentOnFirstWait !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.commentOnFirstWait);
        /* c1.api.policy.v1.WaitCondition condition = 100; */
        if (message.until.oneofKind === "condition")
            WaitCondition.internalBinaryWrite(message.until.condition, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.WaitDuration duration = 101; */
        if (message.until.oneofKind === "duration")
            WaitDuration.internalBinaryWrite(message.until.duration, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.WaitUntilTime until_time = 102; */
        if (message.until.oneofKind === "untilTime")
            WaitUntilTime.internalBinaryWrite(message.until.untilTime, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.Wait
 */
export const Wait = new Wait$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WaitCondition$Type extends MessageType<WaitCondition> {
    constructor() {
        super("c1.api.policy.v1.WaitCondition", [
            { no: 1, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "4096" } } } }
        ]);
    }
    create(value?: PartialMessage<WaitCondition>): WaitCondition {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.condition = "";
        if (value !== undefined)
            reflectionMergePartial<WaitCondition>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WaitCondition): WaitCondition {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string condition */ 1:
                    message.condition = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WaitCondition, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string condition = 1; */
        if (message.condition !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.condition);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.WaitCondition
 */
export const WaitCondition = new WaitCondition$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WaitDuration$Type extends MessageType<WaitDuration> {
    constructor() {
        super("c1.api.policy.v1.WaitDuration", [
            { no: 1, name: "duration", kind: "message", T: () => Duration, options: { "validate.rules": { duration: { required: true, lt: { seconds: "2592000" } } } } }
        ]);
    }
    create(value?: PartialMessage<WaitDuration>): WaitDuration {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WaitDuration>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WaitDuration): WaitDuration {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Duration duration */ 1:
                    message.duration = Duration.internalBinaryRead(reader, reader.uint32(), options, message.duration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WaitDuration, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Duration duration = 1; */
        if (message.duration)
            Duration.internalBinaryWrite(message.duration, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.WaitDuration
 */
export const WaitDuration = new WaitDuration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WaitUntilTime$Type extends MessageType<WaitUntilTime> {
    constructor() {
        super("c1.api.policy.v1.WaitUntilTime", [
            { no: 1, name: "hours", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 23, gte: 0 } } } },
            { no: 2, name: "minutes", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 59, gte: 0 } } } },
            { no: 3, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^(?:[A-Za-z][A-Za-z0-9._+-]*(?:/[A-Za-z0-9._+-]+)+|UTC|GMT)$", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<WaitUntilTime>): WaitUntilTime {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hours = 0;
        message.minutes = 0;
        message.timezone = "";
        if (value !== undefined)
            reflectionMergePartial<WaitUntilTime>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WaitUntilTime): WaitUntilTime {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 hours */ 1:
                    message.hours = reader.uint32();
                    break;
                case /* uint32 minutes */ 2:
                    message.minutes = reader.uint32();
                    break;
                case /* string timezone */ 3:
                    message.timezone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WaitUntilTime, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 hours = 1; */
        if (message.hours !== 0)
            writer.tag(1, WireType.Varint).uint32(message.hours);
        /* uint32 minutes = 2; */
        if (message.minutes !== 0)
            writer.tag(2, WireType.Varint).uint32(message.minutes);
        /* string timezone = 3; */
        if (message.timezone !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.timezone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.WaitUntilTime
 */
export const WaitUntilTime = new WaitUntilTime$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WaitInstance$Type extends MessageType<WaitInstance> {
    constructor() {
        super("c1.api.policy.v1.WaitInstance", [
            { no: 100, name: "condition", kind: "message", oneof: "until", T: () => WaitConditionInstance },
            { no: 104, name: "until_time", kind: "message", oneof: "until", T: () => WaitUntilTimeInstance },
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "state", kind: "enum", T: () => ["c1.api.policy.v1.WaitInstance.WaitInstanceState", WaitInstance_WaitInstanceState, "WAIT_INSTANCE_STATE_"] },
            { no: 3, name: "started_waiting_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "timeout_duration", kind: "message", T: () => Duration },
            { no: 5, name: "timeout", kind: "message", T: () => Timestamp },
            { no: 6, name: "comment_on_timeout", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "4096" } } } },
            { no: 7, name: "comment_on_first_wait", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "4096" } } } },
            { no: 101, name: "succeeded", kind: "message", oneof: "outcome", T: () => WaitInstance_ConditionSucceeded },
            { no: 102, name: "timed_out", kind: "message", oneof: "outcome", T: () => WaitInstance_ConditionTimedOut },
            { no: 103, name: "skipped", kind: "message", oneof: "outcome", T: () => SkippedAction }
        ]);
    }
    create(value?: PartialMessage<WaitInstance>): WaitInstance {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.until = { oneofKind: undefined };
        message.name = "";
        message.state = 0;
        message.commentOnTimeout = "";
        message.commentOnFirstWait = "";
        message.outcome = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<WaitInstance>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WaitInstance): WaitInstance {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.policy.v1.WaitConditionInstance condition */ 100:
                    message.until = {
                        oneofKind: "condition",
                        condition: WaitConditionInstance.internalBinaryRead(reader, reader.uint32(), options, (message.until as any).condition)
                    };
                    break;
                case /* c1.api.policy.v1.WaitUntilTimeInstance until_time */ 104:
                    message.until = {
                        oneofKind: "untilTime",
                        untilTime: WaitUntilTimeInstance.internalBinaryRead(reader, reader.uint32(), options, (message.until as any).untilTime)
                    };
                    break;
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* c1.api.policy.v1.WaitInstance.WaitInstanceState state */ 2:
                    message.state = reader.int32();
                    break;
                case /* google.protobuf.Timestamp started_waiting_at */ 3:
                    message.startedWaitingAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startedWaitingAt);
                    break;
                case /* google.protobuf.Duration timeout_duration */ 4:
                    message.timeoutDuration = Duration.internalBinaryRead(reader, reader.uint32(), options, message.timeoutDuration);
                    break;
                case /* google.protobuf.Timestamp timeout */ 5:
                    message.timeout = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timeout);
                    break;
                case /* string comment_on_timeout */ 6:
                    message.commentOnTimeout = reader.string();
                    break;
                case /* string comment_on_first_wait */ 7:
                    message.commentOnFirstWait = reader.string();
                    break;
                case /* c1.api.policy.v1.WaitInstance.ConditionSucceeded succeeded */ 101:
                    message.outcome = {
                        oneofKind: "succeeded",
                        succeeded: WaitInstance_ConditionSucceeded.internalBinaryRead(reader, reader.uint32(), options, (message.outcome as any).succeeded)
                    };
                    break;
                case /* c1.api.policy.v1.WaitInstance.ConditionTimedOut timed_out */ 102:
                    message.outcome = {
                        oneofKind: "timedOut",
                        timedOut: WaitInstance_ConditionTimedOut.internalBinaryRead(reader, reader.uint32(), options, (message.outcome as any).timedOut)
                    };
                    break;
                case /* c1.api.policy.v1.SkippedAction skipped */ 103:
                    message.outcome = {
                        oneofKind: "skipped",
                        skipped: SkippedAction.internalBinaryRead(reader, reader.uint32(), options, (message.outcome as any).skipped)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WaitInstance, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* c1.api.policy.v1.WaitInstance.WaitInstanceState state = 2; */
        if (message.state !== 0)
            writer.tag(2, WireType.Varint).int32(message.state);
        /* google.protobuf.Timestamp started_waiting_at = 3; */
        if (message.startedWaitingAt)
            Timestamp.internalBinaryWrite(message.startedWaitingAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration timeout_duration = 4; */
        if (message.timeoutDuration)
            Duration.internalBinaryWrite(message.timeoutDuration, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp timeout = 5; */
        if (message.timeout)
            Timestamp.internalBinaryWrite(message.timeout, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string comment_on_timeout = 6; */
        if (message.commentOnTimeout !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.commentOnTimeout);
        /* string comment_on_first_wait = 7; */
        if (message.commentOnFirstWait !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.commentOnFirstWait);
        /* c1.api.policy.v1.WaitConditionInstance condition = 100; */
        if (message.until.oneofKind === "condition")
            WaitConditionInstance.internalBinaryWrite(message.until.condition, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.WaitInstance.ConditionSucceeded succeeded = 101; */
        if (message.outcome.oneofKind === "succeeded")
            WaitInstance_ConditionSucceeded.internalBinaryWrite(message.outcome.succeeded, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.WaitInstance.ConditionTimedOut timed_out = 102; */
        if (message.outcome.oneofKind === "timedOut")
            WaitInstance_ConditionTimedOut.internalBinaryWrite(message.outcome.timedOut, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.SkippedAction skipped = 103; */
        if (message.outcome.oneofKind === "skipped")
            SkippedAction.internalBinaryWrite(message.outcome.skipped, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.WaitUntilTimeInstance until_time = 104; */
        if (message.until.oneofKind === "untilTime")
            WaitUntilTimeInstance.internalBinaryWrite(message.until.untilTime, writer.tag(104, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.WaitInstance
 */
export const WaitInstance = new WaitInstance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WaitInstance_ConditionSucceeded$Type extends MessageType<WaitInstance_ConditionSucceeded> {
    constructor() {
        super("c1.api.policy.v1.WaitInstance.ConditionSucceeded", [
            { no: 1, name: "succeeded_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<WaitInstance_ConditionSucceeded>): WaitInstance_ConditionSucceeded {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WaitInstance_ConditionSucceeded>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WaitInstance_ConditionSucceeded): WaitInstance_ConditionSucceeded {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp succeeded_at */ 1:
                    message.succeededAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.succeededAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WaitInstance_ConditionSucceeded, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp succeeded_at = 1; */
        if (message.succeededAt)
            Timestamp.internalBinaryWrite(message.succeededAt, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.WaitInstance.ConditionSucceeded
 */
export const WaitInstance_ConditionSucceeded = new WaitInstance_ConditionSucceeded$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WaitInstance_ConditionTimedOut$Type extends MessageType<WaitInstance_ConditionTimedOut> {
    constructor() {
        super("c1.api.policy.v1.WaitInstance.ConditionTimedOut", [
            { no: 1, name: "timed_out_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<WaitInstance_ConditionTimedOut>): WaitInstance_ConditionTimedOut {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WaitInstance_ConditionTimedOut>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WaitInstance_ConditionTimedOut): WaitInstance_ConditionTimedOut {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp timed_out_at */ 1:
                    message.timedOutAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timedOutAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WaitInstance_ConditionTimedOut, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp timed_out_at = 1; */
        if (message.timedOutAt)
            Timestamp.internalBinaryWrite(message.timedOutAt, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.WaitInstance.ConditionTimedOut
 */
export const WaitInstance_ConditionTimedOut = new WaitInstance_ConditionTimedOut$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WaitConditionInstance$Type extends MessageType<WaitConditionInstance> {
    constructor() {
        super("c1.api.policy.v1.WaitConditionInstance", [
            { no: 1, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "4096" } } } }
        ]);
    }
    create(value?: PartialMessage<WaitConditionInstance>): WaitConditionInstance {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.condition = "";
        if (value !== undefined)
            reflectionMergePartial<WaitConditionInstance>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WaitConditionInstance): WaitConditionInstance {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string condition */ 1:
                    message.condition = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WaitConditionInstance, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string condition = 1; */
        if (message.condition !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.condition);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.WaitConditionInstance
 */
export const WaitConditionInstance = new WaitConditionInstance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WaitUntilTimeInstance$Type extends MessageType<WaitUntilTimeInstance> {
    constructor() {
        super("c1.api.policy.v1.WaitUntilTimeInstance", [
            { no: 1, name: "until_time", kind: "message", T: () => Timestamp },
            { no: 2, name: "duration_if_exists", kind: "message", T: () => Duration }
        ]);
    }
    create(value?: PartialMessage<WaitUntilTimeInstance>): WaitUntilTimeInstance {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WaitUntilTimeInstance>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WaitUntilTimeInstance): WaitUntilTimeInstance {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp until_time */ 1:
                    message.untilTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.untilTime);
                    break;
                case /* google.protobuf.Duration duration_if_exists */ 2:
                    message.durationIfExists = Duration.internalBinaryRead(reader, reader.uint32(), options, message.durationIfExists);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WaitUntilTimeInstance, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp until_time = 1; */
        if (message.untilTime)
            Timestamp.internalBinaryWrite(message.untilTime, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration duration_if_exists = 2; */
        if (message.durationIfExists)
            Duration.internalBinaryWrite(message.durationIfExists, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.WaitUntilTimeInstance
 */
export const WaitUntilTimeInstance = new WaitUntilTimeInstance$Type();
